import React, { useState } from "react";
import styles from "../../styles";
import { loginStyles } from "./style.js";
import ToggleButton from "react-toggle-button";
import { UserTypes } from "../../config.js";
import "../../styles/index.css";

const Login = ({ signInUser, signUpUser, errMsg, setLocalMode }) => {
  const [isSignIn, toggleSignIn] = useState(true);
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isDeveloper, setIsDeveloper] = useState(false);

  const highlight = (e) => {
    e.target.style.opacity = 0.5;
  };

  const unhighlight = (e) => {
    e.target.style.opacity = 1;
  };

  if (!isSignIn)
    return (
      <div
        style={{
          ...styles.fullScreenContainer,
          ...loginStyles.container,
        }}
      >
        <div style={loginStyles.modal}>
          <div style={loginStyles.label}>Username</div>
          <input
            type="text"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            style={loginStyles.input}
          />
          <div style={loginStyles.label}>Email</div>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={loginStyles.input}
          />
          <div style={loginStyles.label}>Password</div>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={loginStyles.input}
          />
          <div style={loginStyles.label}>Register as an developer</div>
          <div style={loginStyles.label}>
            <ToggleButton
              thumbStyle={{
                boxShadow: "0px 0px 2px white",
              }}
              colors={{
                active: {
                  base: "rgb(207,221,245)",
                  hover: "rgb(177, 191, 215)",
                },
                inactive: {
                  base: "rgb(65,66,68)",
                  hover: "rgb(95,96,98)",
                },
              }}
              inactiveLabel={""}
              activeLabel={""}
              value={isDeveloper}
              onToggle={(value) => setIsDeveloper(!value)}
            />
          </div>

          <div
            style={loginStyles.button}
            onMouseOver={highlight}
            onMouseOut={unhighlight}
            onClick={async () =>
              await signUpUser(
                userName,
                email,
                password,
                isDeveloper ? UserTypes.DEV : UserTypes.IND
              )
            }
          >
            Create Account
          </div>
          <div
            style={{ ...loginStyles.label, textAlign: "center" }}
            onMouseOver={highlight}
            onMouseOut={unhighlight}
            onClick={() => toggleSignIn(!isSignIn)}
          >
            <u>Already have an account?</u>
          </div>
          {errMsg !== "" && (
            <div
              style={{
                ...loginStyles.label,
                color: "red",
                textAlign: "center",
              }}
            >
              {errMsg}
            </div>
          )}
        </div>
      </div>
    );
  else
    return (
      <div
        style={{
          ...styles.fullScreenContainer,
          ...loginStyles.container,
        }}
      >
        <div style={loginStyles.modal}>
          <div style={loginStyles.label}>Email</div>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={loginStyles.input}
            autoComplete="on"
          />
          <div style={loginStyles.label}>Password</div>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={loginStyles.input}
            autoComplete="on"
          />
          <div
            style={loginStyles.button}
            onMouseOver={highlight}
            onMouseOut={unhighlight}
            onClick={async () => await signInUser(email, password)}
          >
            Sign In
          </div>
          <div
            style={{ ...loginStyles.label, textAlign: "center" }}
            onMouseOver={highlight}
            onMouseOut={unhighlight}
            onClick={() => toggleSignIn(!isSignIn)}
          >
            <u>Create an account?</u>
          </div>
          <div
            style={{ ...loginStyles.label, textAlign: "center" }}
            onMouseOver={highlight}
            onMouseOut={unhighlight}
            onClick={() => {
              setLocalMode(true);
            }}
          >
            <u>No connection? Try local mode</u>
          </div>
          {errMsg !== "" && (
            <div
              style={{
                ...loginStyles.label,
                color: "red",
                textAlign: "center",
              }}
            >
              {errMsg}
            </div>
          )}
        </div>
      </div>
    );
};
export default Login;
